import toggleScroll from './hideScroll';

const makePopup = () => {
  $('[data-popup]').on('click', (e) => {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const popupTarget = $target.attr('data-popup');

    if (!popupTarget) {
      return;
    }

    const $popup = $(`.${popupTarget}`);
    const popupTitle = $target.attr('data-popup-title');
    const $popupTitle = $popup.find('.data-popup-title');
    $popup.addClass('popup--active');
    $popup.find('input:first').focus();

    const $parentPopup = $(`.${$target.attr('data-popup-parent')}`);

    if ($parentPopup.length) {
      $parentPopup.removeClass('popup--active');
      return;
    }

    if ($popupTitle.length) {
      $popupTitle.attr('val', '');
    }

    if (popupTitle) {
      $popupTitle.attr('val', popupTitle);
    }

    toggleScroll();
  });

  $('.popup').on('click', (e) => {
    const $target = $(e.target);

    if ($target.hasClass('popup__cell') || $target.hasClass('btn-close') || $target.parent().hasClass('btn-close')) {
      $target.closest('.popup').removeClass('popup--active');
      toggleScroll();
    }
  });

  $(document).on('keydown', (e) => {
    if (e.keyCode === 27 && $('.popup--active').length) {
      $('.popup--active').removeClass('popup--active');
      toggleScroll();
    }
  });
};

export default makePopup;
